import { render, staticRenderFns } from "./calendar-header-month.vue?vue&type=template&id=aace51b4&"
import script from "./calendar-header-month.vue?vue&type=script&lang=js&"
export * from "./calendar-header-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports